import { Chip } from "@mui/material";
import { TagInfo, TagType } from "../types";

// UI Components
const getTagColor = (type: TagType, theme: any) => {
  switch (type) {
    case TagType.NEW:
      return theme.palette.success.light; // Light Green
    case TagType.ALL:
      return theme.palette.primary.main; // Encamp Blue
    case TagType.PARTIAL:
      return theme.palette.grey[300];
  }
};

export const TagChip = ({
  tagInfo,
  onRemove,
  onPromote,
  theme,
}: {
  tagInfo: TagInfo;
  onRemove: (tagName: string) => void;
  onPromote: (tagName: string) => void;
  theme: any;
}) => {
  return (
    <Chip
      label={tagInfo.name}
      onDelete={() => onRemove(tagInfo.name)}
      onClick={() => {
        if (
          tagInfo.type === TagType.PARTIAL ||
          (tagInfo.type === TagType.ALL && tagInfo.originallyPartial)
        ) {
          onPromote(tagInfo.name);
        }
      }}
      variant="filled"
      sx={{
        backgroundColor: getTagColor(tagInfo.type, theme),
        color:
          tagInfo.type === TagType.PARTIAL
            ? theme.palette.text.primary
            : "white",
        cursor:
          tagInfo.type === TagType.PARTIAL ||
          (tagInfo.type === TagType.ALL && tagInfo.originallyPartial)
            ? "pointer"
            : "default",
        "&:hover": {
          backgroundColor: getTagColor(tagInfo.type, theme),
          filter:
            tagInfo.type === TagType.PARTIAL
              ? "brightness(0.9)"
              : tagInfo.type === TagType.ALL && tagInfo.originallyPartial
              ? "brightness(1.2)"
              : "none",
        },
        "& .MuiChip-deleteIcon": {
          color:
            tagInfo.type === TagType.PARTIAL
              ? theme.palette.grey[500]
              : "rgba(255, 255, 255, 0.7)",
          "&:hover": {
            color:
              tagInfo.type === TagType.PARTIAL
                ? theme.palette.grey[700]
                : "rgba(255, 255, 255, 1)",
          },
        },
      }}
    />
  );
};
